import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { emailActions } from '../actions/';
import { SendEmailFailed, SendEmailSuccess } from '../actions/email.actions';
import { EmailApiService } from './../service/email-api.service';
import { notificationActions, NotificationType } from '@content-platform/web-angular-shared-ui-notifications';
import { Store } from '@ngrx/store';
import { LoggerService, actionEnum, eventTypeEnum } from '@content-platform/web-angular-shared-util-logging';
/**
 * The option effects
 *
 */
@Injectable()
export class EmailEffects {
  constructor(
    private actions$: Actions,
    private emailApiService: EmailApiService,
    private logger: LoggerService,
    private store: Store<{}>
  ) {}

  @Effect()
  sendEmail$: Observable<SendEmailFailed | SendEmailSuccess> = this.actions$.pipe(
    ofType(emailActions.SEND_EMAIL),
    map((action: emailActions.SendEmail) => action.payload),
    switchMap((payload) =>
      this.emailApiService.sendEmail(payload).pipe(
        map(() => {
          this.showUserNotification(NotificationType.Success, 'Email request sent successfully');
          return new SendEmailSuccess();
        }),
        catchError((error) => of(new SendEmailFailed(error)))
      )
    ),
    catchError((error) => {
      return [new emailActions.SendEmailFailed({ error, message: 'Unable to send email' })];
    })
  );

  @Effect()
  sendInvitationEmail$$: Observable<SendEmailFailed | SendEmailSuccess> = this.actions$.pipe(
    ofType(emailActions.SEND_INVITATION_EMAIL),
    map((action: emailActions.SendInvitationEmail) => action.payload),
    switchMap((payload) =>
      this.emailApiService.sendExternalInvitationEmail(payload.invitationEmail).pipe(
        map(() => {
          this.logger
            .doLogMegaBeacon(
              eventTypeEnum.USER_EXT_INVITE,
              actionEnum.CREATE,
              '',
              payload.invitationEmail
            )
            .pipe(take(1))
            .subscribe((res) => res);

          return new SendEmailSuccess();
        }),
        catchError((error) => of(new SendEmailFailed(error)))
      )
    ),
    catchError((error) => {
      return [new emailActions.SendEmailFailed({ error, message: 'Unable to send email' })];
    })
  );

  @Effect()
  sendRequestNewUserEmail$: Observable<SendEmailFailed | SendEmailSuccess> = this.actions$.pipe(
    ofType(emailActions.SEND_REQUEST_NEW_USER_EMAIL),
    map((action: emailActions.SendRequestNewUserEmail) => action.payload),
    switchMap((payload) =>
      this.emailApiService.sendRequestNewUserEmail(payload.requestNewUserEmail).pipe(
        map(() => {
          this.logger
            .doLogMegaBeacon(
              eventTypeEnum.USER_EXT_REQUEST,
              actionEnum.CREATE,
              '',
              payload.requestNewUserEmail
            )
            .pipe(take(1))
            .subscribe((res) => res);
          this.showUserNotification(
            NotificationType.Success,
            'Request new user email sent successfully'
          );
          return new SendEmailSuccess();
        }),
        catchError((error) => of(new SendEmailFailed(error)))
      )
    ),
    catchError((error) => {
      return [
        new emailActions.SendEmailFailed({
          error,
          message: 'Unable to send request new user email',
        }),
      ];
    })
  );

  private showUserNotification(notificationType: NotificationType, message: string) {
    this.store.dispatch(
      new notificationActions.Open({
        type: notificationType,
        inputs: {
          props: {
            message: message,
          },
        },
      })
    );
  }
}
